import LogModel from './log-model';
import { doReports, findParent } from './util';
// 判定window对象是否存在，公用函数
export var isWindowExist = function () {
    if (typeof window === 'undefined') {
        console.warn('window 对象不存在，无法获取埋点信息');
        return false;
    }
    return true;
};
var GrassSnakesGrayLines = /** @class */ (function () {
    function class_1(reportDict, config) {
        this.reportDict = reportDict;
        this.config = config;
    }
    class_1.prototype.bury = function (log) {
        var m = new LogModel(log, this.config);
        m.inspectionPassed && doReports(m, this.reportDict);
    };
    return class_1;
}());
export var registerLogTrack = function (reportDict, config) {
    if (isWindowExist() === false) {
        return;
    }
    var gsgl = new GrassSnakesGrayLines(reportDict, config);
    document.addEventListener('click', function (e) {
        if (!(e.target instanceof HTMLElement)) {
            return;
        }
        // 点击的元素本身就可以触发
        if (e.target.dataset.log) {
            var log = e.target.dataset.log;
            gsgl.bury(log);
            return;
        }
        // 点击元素本身不能触发，尝试寻找父元素触发
        var dom = findParent(e.target);
        if (dom) {
            var log = dom.dataset.log;
            gsgl.bury(log);
        }
        else {
            // console.log("最终没有找到可触发的父元素，本次点击未埋点");
        }
    });
    return gsgl;
};
export { LogModel };
//# sourceMappingURL=index.js.map